import { render, staticRenderFns } from "./Subpage.vue?vue&type=template&id=056ea640&"
import script from "./Subpage.vue?vue&type=script&lang=js&"
export * from "./Subpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056ea640')) {
      api.createRecord('056ea640', component.options)
    } else {
      api.reload('056ea640', component.options)
    }
    module.hot.accept("./Subpage.vue?vue&type=template&id=056ea640&", function () {
      api.rerender('056ea640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/Subpage.vue"
export default component.exports